import React         from "react";

import Form          from 'react-bootstrap/Form';
import Row           from 'react-bootstrap/Row';
import Col           from 'react-bootstrap/Col';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

const Etapa1 = ( props ) => {
  
  return (
    <Row>
      <Col md={{ span: 6, offset: 3 }} className="zzbox">

        <Row>
          <Col>
            <FloatingLabel
              controlId = "contato"
              label     = "Seu nome *">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.contato} 
                            onChange    = {props.handleChange} 
                            onBlur      = {props.handleChange} 
                            name        = "contato" />
            </FloatingLabel>
          </Col>
        </Row>

        <br/>

        <Row>
          <Col>
            <FloatingLabel
              controlId = "fone"
              label     = "Telefone *">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.fone} 
                            onChange    = {props.handleChange} 
                            onBlur      = {props.handleChange} 
                            name        = "fone" />
            </FloatingLabel>
          </Col>
        </Row>

        <br/>

        <Row>
          <Col>
            <FloatingLabel
              controlId = "email"
              label     = "Email *">
              <Form.Control type        = "email" 
                            placeholder = "."
                            value       = {props.values.email} 
                            onChange    = {props.handleChange} 
                            onBlur      = {props.handleChange} 
                            name        = "email" 
              />
            </FloatingLabel>
          </Col>
        </Row>

        <br/>

        <Row>
          <Col>
            <FloatingLabel
              controlId = "origem"
              label     = "Como conheceu nosso site?">
              <Form.Control type        = "text" 
                            placeholder = "."
                            value       = {props.values.origem} 
                            onChange    = {props.handleChange} 
                            name        = "origem" 
              />
            </FloatingLabel>
          </Col>
        </Row>

      </Col>
    </Row>
  );
}
export default Etapa1;